import React from 'react'
// components
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccordionOrigin from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import { ReduxInput, ReduxSelect, ReduxEntitySelect } from 'components/FormElements/ReduxForm'
// graphql
import { USERS_SELECT_QUERY } from 'graphql/user/queries'
import { POSITIONS_SELECT_QUERY } from 'graphql/position/queries'
import { BUSINESS_UNITS_SELECT_QUERY } from 'graphql/businessUnit/queries'
// constants
import { PANEL_STYLES } from '../UserData'
import { EMPLOYMENT_STATUS_OPTIONS } from 'constants/users'
// themes
import { colors } from 'themes/index'
// views
import { FieldsContainer } from './views'
// utils
import {
  userProps,
  locationProps,
  positionProps,
  businessUnitProps
} from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'
import { LOCATIONS_SELECT_QUERY } from 'graphql/locations/queries'

const OrganizationData: React.FC = () => {
  return (
    <AccordionOrigin>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>Organisation data</AccordionSummary>
      <AccordionDetails style={PANEL_STYLES}>
        <FieldsContainer>
          <ReduxEntitySelect
            isMultiple
            label={'Positions'}
            menuPlacement={'top'}
            name={'positions'}
            query={POSITIONS_SELECT_QUERY}
            {...positionProps}
          />
          <ReduxSelect label='Employment Status' name='employmentStatus' options={EMPLOYMENT_STATUS_OPTIONS} />
          <ReduxEntitySelect
            isClearable
            name={'reportsTo'}
            menuPlacement={'top'}
            query={USERS_SELECT_QUERY}
            label={'Reports to Person'}
            {...userProps}
          />
          <ReduxInput label='Unique Identifier (external)' name='externalEmployeeId' />
          <ReduxInput label='Code' name='code' />
          <ReduxEntitySelect
            isMultiple
            menuPlacement={'top'}
            name={'businessUnits'}
            label={'Business Units'}
            query={BUSINESS_UNITS_SELECT_QUERY}
            {...businessUnitProps}
          />
          <ReduxEntitySelect
            isMultiple
            menuPlacement={'top'}
            name={'locationIds'}
            label={'Locations'}
            query={LOCATIONS_SELECT_QUERY}
            {...locationProps}
          />
          <ReduxInput label='Azure Directory User Id' name='activeDirectoryId' disabled />
          <ReduxSelect
            isMultiple
            isDisabled
            menuPlacement={'top'}
            name={'activeDirectoryAdministrativeUnits'}
            label={'Azure Directory Organisational Units'}
          />
          <ReduxInput label='Azure Directory Tenant Id' name='activeDirectoryTenantId' disabled />
        </FieldsContainer>
      </AccordionDetails>
    </AccordionOrigin>
  )
}

export default OrganizationData
